// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Webkit Scrollbar Styles */
::-webkit-scrollbar {
  width: 12px; /* 트랙 전체 너비 */
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}
::-webkit-scrollbar-thumb {
  background: #c9cdd3;
  border-radius: 6px;
  border: 2px solid #f1f1f1; /* 트랙 배경색과 동일하게 */
  background-clip: padding-box;
}
::-webkit-scrollbar-thumb:hover {
  background: #9fa4a8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/scrollbar.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,WAAW,EAAE,aAAa;AAC5B;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB,EAAE,iBAAiB;EAC5C,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* Global Webkit Scrollbar Styles */\n::-webkit-scrollbar {\n  width: 12px; /* 트랙 전체 너비 */\n}\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 6px;\n}\n::-webkit-scrollbar-thumb {\n  background: #c9cdd3;\n  border-radius: 6px;\n  border: 2px solid #f1f1f1; /* 트랙 배경색과 동일하게 */\n  background-clip: padding-box;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #9fa4a8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
